import { UseFormReturn } from 'react-hook-form';
import { EventPanelFormType } from '@mark43/cad-api';
import { LoadingIndicator } from '../common/components/loading-indicator';
import { FrEditDispositionContainer } from './components/fr-edit-disposition-container';
import { useUnitDispositionContent } from '../fr-event-common-components/fr-disposition/hooks/use-unit-disposition-content';
import { FrDispositionPageContent } from '../fr-clear-event-page/components/fr-disposition-page-content';
import { useIntegratedForm } from '../forms/use-integrated-form';
import { useDispositionQuery } from '../dispositions/hooks/use-disposition-query';

export function FrEditDispositionPage() {
    const {
        eventId,
        unitId,
        dispositionOptions,
        agencyId,
        agencyTypeGlobalAttrId,
        cautions,
        areCautionsLoading,
        eventLocation,
        eventForm,
    } = useUnitDispositionContent();

    // FR rule: only the unit that last dispositioned the event may edit the primary
    // disposition (additional dispositions stay open to any unit). This is the correct
    // "is my unit primary" signal here — not the current assignment's primary flag, which
    // can point at a different event once this one is cleared.
    const { data: dispositionData } = useDispositionQuery({ agencyEventId: eventId });
    const isPrimaryUnitForEvent =
        unitId != null && unitId === dispositionData?.form.primaryUnitIdFromDisposition;

    const { query: eventQuery } = useIntegratedForm();

    // Only show the full-page loader on the initial load (no cached data yet), not on
    // a background refetch — using `isFetching` blanks the page and causes a flicker
    if (eventQuery.isInitialLoading) {
        return <LoadingIndicator />;
    }

    return (
        <FrEditDispositionContainer eventId={eventId}>
            <FrDispositionPageContent
                isEditDispositionPage
                primaryDispositionEditable={isPrimaryUnitForEvent}
                saveMutationErrorMsg="updating disposition"
                eventId={eventId}
                unitId={unitId}
                isPrimaryUnit={isPrimaryUnitForEvent}
                dispositionOptions={dispositionOptions}
                agencyId={agencyId}
                agencyTypeGlobalAttrId={agencyTypeGlobalAttrId}
                cautions={cautions}
                areCautionsLoading={areCautionsLoading}
                eventLocation={eventLocation}
                eventForm={(eventForm as unknown) as UseFormReturn<EventPanelFormType>}
            />
        </FrEditDispositionContainer>
    );
}
